import React from 'react';
import { useContext } from 'react';
import './../../../Styles/Main/RentalPage/RentalRequest.scss';
import PagesWrapper from '../../../UI/pagewrapper/PagesWrapper';
import PageConnector from '../../../UI/pageconnector/PageConnector';
import { useState } from 'react';
import RentalRequestedStaff from './RentalRequestedStaff';
import RentalRequestedForm from './RentalRequestedForm';
import RentalOrderProcessed from './RentalOrderProcessed';

function RentalRequest(props) {

   const [goBookPage, setGoBookPage] = useState(false);

   const checkForm = (value) => {
      setGoBookPage(value)
   }

   return (
      <div className='rentalRequest__wrapper'>
         {goBookPage
            ?
            <PagesWrapper>
               <div className="rentalRequest__title title-h1">Order successfully completed</div>
               <RentalOrderProcessed/>
            </PagesWrapper>
            :
            <div>
               <PagesWrapper>
                  <div className="rentalRequest__procces">
                     <div className="rentalRequest__title title-h1">Bicycle rental request</div>
                     <RentalRequestedStaff/>
                  </div>
               </PagesWrapper>
               <PagesWrapper>
                  <div className="rentalRequest__form">
                     <span><PageConnector/></span>
                     <RentalRequestedForm checkForm={ checkForm } />
                  </div>
               </PagesWrapper>
            </div>
         }
      </div>
   );
}
export default RentalRequest;